import { Guid } from "guid-typescript";

class MessageLogRecipient {
    id: Guid;
    address: string;
    completed: Date;

    constructor(data: Partial<MessageLogRecipient>) {
        Object.assign(this, data);

        if (typeof this.completed === "string")
            this.completed = new Date(this.completed);
    }
}

export default MessageLogRecipient;